import { ButtonBase, styled, Typography } from '@mui/material';

export const Badge = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.palette.secondary.main};
  width: ${({ theme }) => theme.typography.pxToRem(20)};
  height: ${({ theme }) => theme.typography.pxToRem(20)};
`;

export const BadgeCount = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem(12)};
  line-height: 1;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;
